<template>
	<div class="bg2">
		<Header url="/my" title="订单" background="#ffffff"></Header>
		<div class="status">
			<span class="status" v-if="item.status==1">待出库</span>
			<span class="status" v-if="item.status==2">待出库</span>
			<span class="status" v-if="item.status==3">待支付</span>
			<span class="status" v-if="item.status==4">待发货</span>
			<span class="status" v-if="item.status==5">待收货</span>
			<span class="status" v-if="item.status==6">已收货</span>
			<span class="status" v-if="item.status==8">已出库</span>
			<span class="status" v-if="item.status==-1">申请退款中</span>
			<span class="status" v-if="item.status==-2">下单失败待退款</span>
			<span class="status" v-if="item.status==-100">已退款/订单取消</span>
		</div>
		<div class="address"
			v-if="item.status==1||item.status==2||item.status==3||item.status==4||item.status==5||item.status==6||item.status==8">
			<h5 class="name">我的地址</h5>
			<p class="line"></p>
			<div class="addres flex-center">
				<img src="../../assets/my/add@2x.png" alt="" />
				<div class="addRight">
					<div class="msg flex-center">
						<h5>{{item.consigneeName}}</h5>
						<span>{{item.consigneeMobile}}</span>
					</div>
					<p>{{item.consigneeAddress}}</p>
				</div>
			</div>
		</div>
		<div class="goodsDetial">
			<h5>商品详情</h5>
			<p class="line"></p>
			<div class="list flex-center" v-for="list in item.goodsList">
				<img :src="list.goodsThumb" alt="" />
				<div class="orderMsg">
					<p>{{list.goodsTitle}}</p>
					<p>{{list.unitPriceJp}}日元({{list.unitPrice}}人民币)</p>
					<p>
						<span class="status" v-if="list.status==1">待出库</span>
						<span class="status" v-if="list.status==2">待出库</span>
						<span class="status" v-if="list.status==3">待支付</span>
						<span class="status" v-if="list.status==4">待发货</span>
						<span class="status" v-if="list.status==5">待收货</span>
						<span class="status" v-if="list.status==6">已收货</span>
						<span class="status" v-if="item.status==8">已出库</span>
						<span class="status" v-if="list.status==-1">申请退款中</span>
						<span class="status" v-if="list.status==-2">下单失败待退款</span>
						<span class="status" v-if="list.status==-100&&list.refundAt">已退款</span>
						<span class="status" v-if="list.status==-100&&!list.refundAt">订单取消</span>
					</p>
				</div>
			</div>
		</div>
		<div class="feeCar"
			v-if="item.status==1||item.status==2||item.status==3||item.status==4||item.status==5||item.status==6||item.status==8">
			<h5>费用详情</h5>
			<p class="line"></p>
			<ul>
				<li class="color"><span>手续费</span><span>{{item.commissionFee}}</span></li>
				<li class="color"><span>优惠金额</span><span>{{item.discount}}</span></li>
				<li><span>商品价格</span><span>{{item.goodsPriceJp}}日元({{item.goodsPrice}}人民币)</span></li>

				<!-- <li><span>商品重量</span><span>10g</span></li> -->
				<!-- <li><span>运费(100g=11人民币)</span><span>110人民币</span></li> -->
				<li><span>运费</span><span>{{item.freight}}人民币</span></li>
				<li v-if="item.freightRemark"><span>运费备注</span><span>{{item.freightRemark}}</span></li>

				<li><span>商品总价(含手续费)</span><span>{{item.price*1+item.freight*1}}人民币</span></li>
			</ul>
		</div>
		<div class="feeCar"
			v-if="item.status==1||item.status==2||item.status==3||item.status==4||item.status==5||item.status==6||item.status==8">
			<h5>订单信息</h5>
			<p class="line"></p>
			<ul>
				<li><span>收件人</span><span>{{item.consigneeName}}</span></li>
				<li><span>联系方式</span><span>{{item.consigneeMobile}}</span></li>
				<li>
					<span>订单编号</span>
					<p><span>{{item.orderNo}}</span> <img src="" alt="" /></p>
				</li>

				<!-- <li><span>订单规格</span><span>红色，小</span></li> -->
				<li><span>数量</span><span v-if="item.goodsList">{{item.goodsList.length}}</span></li>
				<li><span>购买时间</span><span>{{item.paidAt}}</span></li>
			</ul>
		</div>
		<div class="feeCar" v-if="item.status==-1||item.status==-2||item.status==-100">
			<h5>退款详情</h5>
			<p class="line"></p>
			<ul>
				<li><span>退款原因</span><span>{{item.refundReason}}</span></li>
				<li><span>退款金额</span><span>{{item.price}}人民币</span></li>
				<li><span>申请时间</span><span>{{item.refundAt}}</span></li>
				<li v-if="item.status==-2||item.status==-100"><span>退款时间</span><span>{{item.updatedAt}}</span></li>
			</ul>
		</div>
		<div class="btns">
			<!-- <span v-if="item.status==1||item.status==2||item.status==8" @click.stop="closeOrder(item.id)">取消订单</span> -->
			<span class="status" v-if="item.status==3" @click.stop="playPay(item.id)">立即支付</span>
			<span v-if="item.status==4||item.status==5" @click.stop="goUrl('/my/tuiDetails?id=',item,1)">申请退款</span>
			<span v-if="item.status==5" @click="goUrl('/my/wuliu?id=',item,1)">查看物流</span>
			<span class="status" v-if="item.status==5" @click="confirmGoods(item.id)">确认收货</span>
		</div>
		<van-action-sheet title="取消订单原因" v-model="showCloseOrder" :actions="closeOrderList" cancel-text="取消"
			close-on-click-action @select="closeOrder" />
	</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				item: '',
				id: '',
				showCloseOrder: false,
				closeOrderList: [{
						name: '商品与描述不符'
					},
					{
						name: '发错商品'
					},
					{
						name: '其他'
					},
				],
			};
		},
		computed: {},
		methods: {
			goUrl(path, item, type) {
				if (type) {
					this.$router.push(path + JSON.stringify(item))
				} else {
					this.$router.push(path + item)
				}

			},
			getInfo() {
				this.$post({
					url: "/portal/Shop",
					module: "Order",
					interface: "2100",
					data: {
						id: this.id
					},
				}).then((res) => {
					this.item = res
				});
			},
			showClose() {
				this.showCloseOrder = true;
			},
			//立即支付
			playPay(id) {
				let ids = Array();
				ids.push(id)
				this.$post({
						url: "/portal/Shop",
						module: "Order",
						interface: "1104",
						data: {
							ids: ids,
							payType: '220'
						},
					})
					// .then((res) => {
					// 	this.$toast('支付成功')
					// 	this.getInfo()
					// })
					.then((res) => {
						let sign = JSON.parse(res.charge)
						// console.log(sign,333)
						let _this = this;
						WeixinJSBridge.invoke(
							'getBrandWCPayRequest', {
								"appId": sign.appId, //公众号名称，由商户传入     
								"timeStamp": sign.timeStamp.toString(), //时间戳，自1970年以来的秒数     
								"nonceStr": sign.nonceStr, //随机串     
								"package": sign.package,
								"signType": "MD5", //微信签名方式：     
								"paySign": sign.paySign //微信签名 
							},
							function(res) {
								if (res.err_msg == "get_brand_wcpay_request:ok") {
									// _this.$toast('支付成功')
									// _this.buySuccess(ids)
									// _this.$toast('支付成功')
									// _this.form.page=1;
									// _this.selectOrder()
									this.$toast('支付成功')
									this.getInfo()
								} else {
									_this.$toast('支付失败，请稍后再试')
								}
							}
						);

					})
					.catch((error) => {
						console.log(error);
						// this.$router.replace({
						//   name: "classifyCommoditysuccess",
						//   params: {
						//     payMoney: this.info.goodsPrice,
						//     success: false,
						//   },
						// });
					});
			},
			// 确认收货
			confirmGoods(id) {
				let _this = this
				this.$dialog.confirm({
						title: '确认收货',
						message: '是否确认收货',
					})
					.then(() => {
						let ids = Array();
						this.$post({
							url: "/portal/Shop",
							module: "Order",
							interface: "3003",
							data: {
								id: id
							},
						}).then((res) => {
							this.$toast('确认成功')
							this.form.page = 1;
							this.selectOrder()
						})
					})
					.catch(() => {
						// on cancel
					});
			},
			//取消订单
			closeOrder(id) {
				this.$post({
					url: "/portal/Shop",
					module: "Order",
					interface: "3000",
					data: {
						id: id,
						// reason:e.name
					},
				}).then((res) => {
					this.$toast('取消成功')
					this.getInfo()
				})

			},
		},
		created() {
			this.id = this.$route.query.id;
			this.getInfo();
		},
	};
</script>

<style lang='less' scoped>
	.status {
		height: 73px;
		background: #e63a2a;
		color: #ffffff;
		display: flex;
		align-items: center;
		padding-left: 15px;
	}

	.address {
		margin: 14px 0;
		background: #ffffff;
		box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
		border-radius: 12px;

		.name {
			height: 50px;
			line-height: 50px;
			padding-left: 16px;
		}

		.line {
			height: 2px;
			background: linear-gradient(90deg, #fd0212 0%, #ffffff 100%);
			opacity: 0.3;
		}

		.addres {
			height: 100px;
			padding: 0 5px;

			img {
				width: 30px;
				height: 30px;
				margin-right: 10px;
			}

			.addRight {}
		}

		.addRight {
			.msg {
				h5 {
					font-size: 18px;
					margin-right: 10px;
				}

				span {
					color: #919398;
					font-size: 15px;
				}
			}

			p {
				color: #606266;
				font-size: 15px;
				line-height: 30px;
			}
		}
	}

	.line {
		height: 2px;
		background: linear-gradient(90deg, #fd0212 0%, #ffffff 100%);
		opacity: 0.3;
	}

	.feeCar {
		margin-top: 15px;
		background: #ffffff;
		box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
		border-radius: 12px;

		h5 {
			padding-left: 16px;
			height: 50px;
			line-height: 50px;
			font-size: 16px;
		}

		ul {
			padding: 16px;

			li {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 30px;
				font-size: 13px;
			}

			.color {
				span:nth-child(2) {
					color: #9d28b0;
				}
			}
		}
	}

	.goodsDetial {
		background: #ffffff;
		box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
		border-radius: 12px;
		padding-bottom: 30px;

		h5 {
			height: 50px;
			padding-left: 15px;
			line-height: 50px;
			font-size: 16px;
		}

		.list {
			padding-top: 16px;
			padding-left: 16px;

			img {
				width: 88px;
				height: 82px;
				margin-right: 10px;
			}

			.orderMsg {
				/* height: 70px; */
				padding-bottom: 10px;
				display: flex;
				justify-content: space-between;
				flex-direction: column;
				color: #303133;
				font-size: 14px;
				border-bottom: 1px solid #f0f0f0;

				p:nth-child(2) {
					font-size: 13px;
					color: #fd0212;
				}

				.status {
					display: inline;
					background: #fff;
					color: #e63a2a;
					padding-left: 0;
				}
			}
		}
	}

	.btns {
		height: 60px;
		display: flex;
		justify-content: flex-end;
		background: #ffffff;
		width: 100%;
		margin-top: 14px;
		padding: 12px 14px 0 0;

		span {
			width: 68px;
			height: 26px;
			font-size: 12px;
			text-align: center;
			line-height: 26px;
			border-radius: 4px;
			border: 1px solid #e63a2a;
			color: #e63a2a;
			background: #e63a2a;
			border-radius: 4px;
			margin-left: 10px;
			color: #ffffff;

			&.status {
				color: #fff;
				display: block;
				padding-left: 0;
				/* padding-left:0; */
				/* text-align:center; */
			}
		}

		span:nth-child(1) {
			/* background: #e63a2a; */
			border: 1px solid #e63a2a;
			color: #e63a2a;
			background: #fff;
			border-radius: 4px;
			margin-left: 0px;
			/* color: #ffffff; */
		}
	}
</style>
